window.addEventListener("load", (event) => {

    //set_tax_cookie('check_tax');
    set_last_breadcrumb_item();
});
function set_reference_item_link_to_cookie(name,value,days,identity) {
    var expires = "";
    var current_site_link = $(location).attr("href");

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    if(reference_item_handle !== null ){
        if(current_site_link == value ){
            console.log("Notice: Same collection link");
            return;
        }else{
            clear_reference_item_cookie(name);
            
            document.cookie = name + "=" + (value || "")  + expires + "; path=/";
        }

    }else{
        console.log('First cookie set');
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
        
    }
}

// Gets the data stored in a cookie
function get_cookie_data(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

// Clears a given cookie
function clear_reference_item_cookie(name){
    // Clear all product cookies 
    console.log('Info: Cookie cleared');
    //document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = name + "=" + "" + "expires=Thu, 01 Jan 1970 00:00:01 GMT;" + "path=/";
}

function set_last_breadcrumb_item(){
    var breadcrumb_link = get_cookie_data('collectionlink');

    if(breadcrumb_link != null && breadcrumb_link != 'undefined' && $('.last-item').length > 0 ){
        $('› <a href="'+breadcrumb_link+'" >last Item</a>').insertAfter($('.last-item'));
    }
}


$('.block-swatch__radio').on('change', function(){
    var handleArr = [];
    var variantOptionValue = $(this).val();
    var product_id = $(this).attr('data-product-id');
    var product_handle = $(this).attr('data-product-handle');
    var shopifyUrl = '/admin/api/2023-01/products./'+product_id+'.json';
    var handle_url = '/products/'+product_handle+'.js';

    var variant_price = $(this).attr('data-variant-tax-price');
    var variant_no_tax_price = $(this).attr('data-variant-no-tax-price');
    var variant_stock_text = $(this).attr('data-variant-stock-text');
    var variant_stock_number = $(this).attr('data-variant-stock-number');
    var variant_vendors_number = $(this).attr('data-variant-vendor-number');
    var variant_db_number = $(this).attr('data-variant-db-number');
    var variant_sold_out = $(this).attr('data-variant-sold-out');
    var available = $(this).attr('data-variant-available');
    setTimeout(() => {
        
        $('.product-meta__plytix.vendor-number').html('<b>Leverandørvarenr: </b><span>'+variant_vendors_number+'</span>');
        $('.product-meta__plytix.db-number').html('<b>DB-nummer: </b><span>'+variant_db_number+'</span>');

        if( variant_sold_out == "true"){
            if(variant_stock_text == "Ikke på lager"){
                $('.product-form__info-list .product-item__inventory').html('<span class="plytix-field-low-stock">'+variant_stock_text+'</span>');

            }else{
                $('.product-form__info-list .product-item__inventory').html('<span class="plytix-field-high-stock">'+variant_stock_text+'</span>');

            }
        //     $('.product-form__add-button').removeClass('button--primary');
        //     $('.product-form__add-button').addClass('button--disabled');
        //     $('.product-form__add-button').attr('disabled', 'disabled');
        //     $('.product-form__add-button').text('Udsolgt');
        }else{
            $('.product-form__info-list .product-item__inventory').html('<span class="plytix-field-high-stock">'+variant_stock_text+'</span>');
        //     $('.product-form__add-button').removeClass('button--disabled');
        //     $('.product-form__add-button').addClass('button--primary');
        //     $('.product-form__add-button').removeAttr('disabled');
        //     $('.product-form__add-button').text('Tilføj til kurv');
            
        }
        $('span.price.price-with-tax').html(variant_price + ' <span class="small-font">(inkl. moms)</span>');
        $('span.price.price-no-tax').html(variant_no_tax_price+ ' <span class="small-font">(eksl. moms)</span>');
    }, 100);
})


// /**
//  * 
//  * @returns Device orientation
//  */
// function isMobileDeviceInLandscape() {
//     return (typeof window.orientation !== "undefined") && (window.orientation === 90 || window.orientation === -90);
// }
  

// /* 
// 	Check if the user is on a mobile device
// */
// function isMobileDevice() {
//     return /Mobile|iPhone|iPad|Android|Windows Phone|BlackBerry|Opera Mini/i.test(navigator.userAgent);
// }

async function setTaxCookie(cookieName, source) {
    try{
        console.log('Set tax cookie');
        const days = 5;
        let cookieSetting = getCookieSetting(cookieName);
        const toggleSwitch = document.getElementById('tax-toggle');
        console.log(cookieSetting);
        console.log(cookieName);
        let value = source !== "initial" ? source : (toggleSwitch.checked ? 'with_tax' : 'without_tax');

        if (!cookieSetting) {
            console.log(cookieSetting, cookieName, 'NO COOKIE SETTING');
            value = 'with_tax';
        }

    
        if (source === "initial" && cookieSetting) {
            //toggleSwitch.checked = (cookieSetting === 'with_tax');
            console.log('Initial cookie');
            await checkAndSetPriceUI(cookieName);
            return;
        }
    
        let expires = "";
    
        if (days && days > 0) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = `${cookieName}=${value || ""}${expires}; path=/`;

        
        await checkAndSetPriceUI(cookieName);

    }catch(error){
        console.log('Error: ', error);
    }finally{
        removeLoader();
    }
    
}

/**
 * Gets the data stored in cookies
 *  */ 
function getCookieSetting(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
} 

/**
 * 
 * @param {*} cookie_name 
 */
async function checkAndSetPriceUI(cookie_name){
    var cookie_setting = getCookieSetting(cookie_name);
    checked = true;
    const toggleSwitch = document.querySelector('input.tax-setting');
    //const variant = getCurrentlySelectedVariantData();
    //insertVariantPriceOnChange(variant);

    console.log('Cookie setting: ',cookie_setting);
    if (cookie_setting == 'with_tax') {
        toggleSwitch.checked = true;
    
        // Pricelist add/remove active - with tax active
        document.querySelectorAll('.custom-list.without-tax').forEach(function(element) {
            element.classList.remove('active');
        });

        document.querySelectorAll('.custom-list.with-tax').forEach(function(element) {
            element.classList.add('active');
        });
        
    

        document.querySelectorAll('span.price.price-with-tax').forEach(function(element) {
            element.classList.add('active');
        });
        document.querySelectorAll('span.price.price-no-tax').forEach(function(element) {
            element.classList.remove('active');
        });
    
        // Normal prices fix
       /* document.querySelectorAll('.normal-price .price-with-tax').forEach(function(element) {
            element.classList.remove('active');
        });

        document.querySelectorAll('.custom-list.with-tax').forEach(function(element) {
            element.classList.add('active');
        });*/
    
    } else {
        toggleSwitch.checked = false;
    
        // Pricelist add/removeactive - without tax active
        document.querySelectorAll('.custom-list.with-tax').forEach(function(element) {
            element.classList.remove('active');
        });

        document.querySelectorAll('.custom-list.without-tax').forEach(function(element) {
            element.classList.add('active');
        });
        


        document.querySelectorAll('span.price.price-with-tax').forEach(function(element) {
            element.classList.remove('active');
        });
        document.querySelectorAll('span.price.price-no-tax').forEach(function(element) {
            element.classList.add('active');
        });
    
        // document.querySelectorAll('.price-list').forEach(function(element) {
        //     element.style.flexDirection = "column-reverse";
        // });
    }

}

/**
 * 
 * @param {*} name 
 */
function clearCookie(name){
    // Clear all product cookies
    console.log('Info: Cookie cleared');
    //document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = name + "=" + "" + "expires=Thu, 01 Jan 1970 00:00:01 GMT;" + "path=/";
    setTimeout(() => {
        renderMatchingProducts();
        jQuery('#compare-container .data-fields').html('');
    }, 150);
}




/**
 * 
 */
function removeLoader(){
    const priceContainer = document.querySelectorAll('.custom-list');
    const loader = document.querySelectorAll('.loader');

    if (loader) {
        loader.forEach(function(e){
            e.style.display = "none";
        })
    }
}

function insertVariantPriceOnChange(variant) {
    const toggleSwitch = document.querySelector('input.tax-setting');
    console.log('The new variant');
    console.log(variant);

    if (variant) {
        let html;
        
        // Convert price to kr and remove tax
        let normalPrice = (variant.price / 100);
        let priceNoTax = (variant.price / 100) * 0.8;
        let compareAtPriceNoTax = variant.compare_at_price ? (variant.compare_at_price / 100) * 0.8 : null;

        // Format prices to 2 decimal places and replace dot with comma for kr format
        let formattedPriceNoTax = priceNoTax.toFixed(2).replace('.', ',');
        let formattedCompareAtPriceNoTax = compareAtPriceNoTax ? compareAtPriceNoTax.toFixed(2).replace('.', ',') : null;

        let formattedNormalPrice = normalPrice.toFixed(2).replace('.', ',');

        console.log('Formatted price no tax: ', formattedPriceNoTax);
        console.log('Formatted price tax: ', formattedPriceNoTax);

        if (compareAtPriceNoTax) {
            // If there's a compare_at_price, show both sale price and original price
            html = `
                <span class="price price-no-tax">
                    <span class="price price-sale">${formattedPriceNoTax} kr <span class="small-font">(eksl. moms)</span></span>
                
                    <span class="price price-old">
                        ${formattedCompareAtPriceNoTax} kr <span class="small-font">(eksl. moms)</span>
                    </span>
                </span>            
            `;
        } else {
            // If there's no compare_at_price, show only the current price
            html = `
                <div class="normal-prices">
                    <span class="price price-with-tax">
                        <div class="normal-price" >
                            <span class="price js-price" style="display:flex;align-items:baseline;gap:10px">${formattedNormalPrice} kr <span class="small-font">(inkl. moms)</span></span>
                        </div>
                    </span>
                    <span class="price price-no-tax">
                        <div class="normal-price">
                            <span class="price js-price" style="color:#000;display:flex;align-items:baseline;gap:10px">${formattedPriceNoTax} kr <span class="small-font">(eksl. moms)</span></span>
                        </div>
                    </span>
                </div>
                
            `;
        }

        // Create a new element from the HTML
        // let tempDiv = document.createElement('div');
        // tempDiv.innerHTML = html;

        // // Append each child of the temporary div to the target element
        // document.querySelector('.product-form__info-item .custom-list.active').append(...tempDiv.children);
        // Assuming you have a target element where this HTML should be inserted, e.g.:
        
        document.querySelector('.product-form__info-item .custom-list.active').innerHTML = html;
        // const value = toggleSwitch.checked ? 'with_tax' : 'without_tax';
        // setTaxCookie('check_tax', value);
    }
}


/**
 * 
 */
window.addEventListener('load', function(){
    //getMetafieldsFromExternal();
    // Initialize cookie setting on load
    setTaxCookie('check_tax', "initial");
    const toggleSwitch = document.querySelector('input.tax-setting');

    document.addEventListener('variant:changed', function(event) {
        var variant = event.detail.variant; 
        console.log('Variant changed');
        insertVariantPriceOnChange(variant);
    });

        
    // document.getElementById('set-with-tax').addEventListener('click', () => {
    //     setTaxCookie('check_tax', 'with_tax');
    // });

    // document.getElementById('set-without-tax').addEventListener('click', () => {
    //     setTaxCookie('check_tax', 'without_tax');
    // });

    // listener for  toggle switch
    toggleSwitch.addEventListener('change', () => {
        const value = toggleSwitch.checked ? 'with_tax' : 'without_tax';
        setTaxCookie('check_tax', value);
    });

});